// source: pbtypes/gen/executive_manager/command_type.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.executive_manager.CommandType', null, global);
goog.exportSymbol('proto.executive_manager.CommandType.Enum', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.executive_manager.CommandType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.executive_manager.CommandType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.executive_manager.CommandType.displayName = 'proto.executive_manager.CommandType';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.executive_manager.CommandType.prototype.toObject = function(opt_includeInstance) {
  return proto.executive_manager.CommandType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.executive_manager.CommandType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.executive_manager.CommandType.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.executive_manager.CommandType}
 */
proto.executive_manager.CommandType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.executive_manager.CommandType;
  return proto.executive_manager.CommandType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.executive_manager.CommandType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.executive_manager.CommandType}
 */
proto.executive_manager.CommandType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.executive_manager.CommandType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.executive_manager.CommandType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.executive_manager.CommandType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.executive_manager.CommandType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.executive_manager.CommandType.Enum = {
  INVALID: 0,
  VIO_INITIALIZE: 1,
  LAND: 4,
  STOP_MOTORS: 5,
  ARM: 6,
  DISARM: 7,
  HAND_TAKEOFF: 9,
  SUBJECT_FOCUS: 11,
  PREP: 14,
  REST: 15,
  IGNORE_OBSTACLES: 16,
  IGNORE_SOME_FAULTS: 17,
  UNINITIALIZE: 18,
  SMART_LAND: 19,
  ABORT_LANDING: 20,
  HOVER: 21,
  TRACK_AIRHAWK: 22,
  LAND_AT_BASESTATION: 23,
  RETURN_AND_LAND_AT_DOCK: 24,
  RETURN_TO_DOCK: 25,
  ABORT_DOCK_RETURN: 26,
  RETURN_TO_SAFE_LANDING: 28,
  PERCH: 29,
  STOP_PERCH: 30,
  ABORT_SAFE_LANDING: 31,
  ABORT_LOW_BATTERY_RETURN: 32
};

goog.object.extend(exports, proto.executive_manager);
